import {TextModel} from "models/Text"
import {HeaderLanguageType} from "@next/utils"
import {joinArrayBasedOnLanguage} from "../../joinArrayBasedOnLanguage"
import {genderGroups} from "../../../config/constants"

export const getGenderGroup = gender => {
    let findGenderGroup = ""
    Object.keys(genderGroups).forEach(group => {
        const genderGroup = genderGroups[group]
        genderGroup.forEach(genderGroupItem => {
            if (genderGroupItem === gender) {
                findGenderGroup = group
            }
        })
    })

    return findGenderGroup
}

const updateGender = (genderArray: string[], headerLanguage: HeaderLanguageType, text: TextModel): string => {
    let singleGender = ""
    let mixedGenders = ""
    let previousGenderGroup
    genderArray.forEach(gender => {
        if (gender.includes("unisex")) {
            return
        }
        const genderGroup = getGenderGroup(gender)
        if (!singleGender) {
            singleGender = text.pages.seoMetaData.genderValues[genderGroup]
        }

        if (!mixedGenders && previousGenderGroup && previousGenderGroup !== genderGroup) {
            mixedGenders = joinArrayBasedOnLanguage(
                headerLanguage,
                genderArray.map(a => text.pages.seoMetaData.genderValues[a]),
            )
        }

        previousGenderGroup = genderGroup
    })
    return mixedGenders || singleGender
}

export default updateGender
